var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-brush-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A53D6",
    d: "M15.456 44.555c-1.421 0-2.826-.347-4.216-1.042a10.402 10.402 0 0 1-1.407-.844c-.918-.657-.345-2.192.554-2.875.853-.647 1.28-1.586 1.28-2.818 0-1.579.552-2.921 1.657-4.026 1.106-1.106 2.448-1.658 4.027-1.658 1.579 0 2.92.552 4.026 1.658 1.105 1.105 1.658 2.447 1.658 4.026 0 2.084-.742 3.868-2.227 5.353-1.484 1.484-3.268 2.226-5.352 2.226Zm0-3.79c1.042 0 1.934-.37 2.676-1.113.742-.742 1.113-1.634 1.113-2.676 0-.537-.181-.987-.544-1.35a1.837 1.837 0 0 0-1.35-.545c-.537 0-.987.182-1.35.545-.364.363-.545.813-.545 1.35a7.14 7.14 0 0 1-.26 1.99c-.128.44-.285.863-.472 1.27-.109.235-.001.53.258.53h.474Zm13.5-10.184a3.684 3.684 0 0 1-5.21-5.21l14.352-14.353c.347-.347.782-.529 1.303-.545.52-.015.97.166 1.35.545l2.558 2.558c.379.379.568.821.568 1.326 0 .506-.19.948-.569 1.327L28.957 30.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#intro-brush-b)",
    fillOpacity: 0.6,
    d: "M15.456 44.555c-1.421 0-2.826-.347-4.216-1.042a10.402 10.402 0 0 1-1.407-.844c-.918-.657-.345-2.192.554-2.875.853-.647 1.28-1.586 1.28-2.818 0-1.579.552-2.921 1.657-4.026 1.106-1.106 2.448-1.658 4.027-1.658 1.579 0 2.92.552 4.026 1.658 1.105 1.105 1.658 2.447 1.658 4.026 0 2.084-.742 3.868-2.227 5.353-1.484 1.484-3.268 2.226-5.352 2.226Zm0-3.79c1.042 0 1.934-.37 2.676-1.113.742-.742 1.113-1.634 1.113-2.676 0-.537-.181-.987-.544-1.35a1.837 1.837 0 0 0-1.35-.545c-.537 0-.987.182-1.35.545-.364.363-.545.813-.545 1.35a7.14 7.14 0 0 1-.26 1.99c-.128.44-.285.863-.472 1.27-.109.235-.001.53.258.53h.474Zm13.5-10.184a3.684 3.684 0 0 1-5.21-5.21l14.352-14.353c.347-.347.782-.529 1.303-.545.52-.015.97.166 1.35.545l2.558 2.558c.379.379.568.821.568 1.326 0 .506-.19.948-.569 1.327L28.957 30.58Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "intro-brush-b",
    x1: 25.877,
    x2: 25.877,
    y1: 10.472,
    y2: 44.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-brush-a",
    width: 46.51,
    height: 46.083,
    x: 3.367,
    y: 7.472,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2427_47316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.117647 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2427_47316",
    result: "effect2_dropShadow_2427_47316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2427_47316",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "ef8b041246b0768d9afa851e59d41fd6.svg";
export { ForwardRef as ReactComponent };